<template>
  <div>
    <div class="d-flex bg-light rounded p-1">
      <span class="time text-end mr-1">{{ time }}</span>
      <span class="label flex-grow-1">{{ label }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TrackerEventElement',
  props: {
    element: {
      type: Object,
      required: true
    }
  },
  computed: {
    time() {
      return new Date(this.element.datetime).toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    label(){
     // console.log("type", this.element.type);
      const content = this.element.content;
      if (this.element.type === "geofencing"){
        const inside = content.inside===true;
        const zone_name = content.zone.name;
        if (inside){
          return app.$t('zone_enter') + " " + zone_name;
        } else {
          return app.$t('zone_exit') + " " + zone_name;
        }

      } else if (this.element.type === "alarm_move") {
        return app.$t('alarm_move');
      } else if (this.element.type === "alarm_orientation_change") {
        return app.$t('alarm_orientation_change');
      } else if (this.element.type === "key_press") {
        return app.$t('key_press');
      } else {
        return this.element.type;
      }
    }
  }
}
</script>
